export const UserRequestToJoinCompanyFragment = gql`
  fragment UserRequestToJoinCompanyFragment on UserRequestToJoinCompany {
    createdAt
    company {
      ...CompanyFragment
    }
    user {
      ...UserDataFragment
    }
  }
`
